module.exports = __webpack_public_path__ + "files/706636834aaed5a6c873b4a3c46bb4a1.png";